// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
	function scrollDown(){
		var top = $(document).scrollTop();
		 
		if (top > 0) {
			$('.header').addClass('scroll');
			$('.header__return').addClass('scroll');
		} else {
			$('.header').removeClass('scroll');
			$('.header__return').removeClass('scroll');
		}
	}

	$(document).ready(function () {
		if ( $('.topalert').length ) {
			$('.header__return').addClass('w-alert');		
		} else {
			$('.header__return').removeClass('w-alert');
		}

		$(window).scroll(function (event) {
			scrollDown();
			
		});
		
		$('.showIframe').fancybox({
			padding:0
		});

		// $("#home .header__btn").hide();
		// $(window).scroll(function() {
		// 	if ($(window).scrollTop() > 750) {
		// 		$("#home .header__btn").fadeIn("slow");
		// 	}
		// 	else {
		// 		$("#home .header__btn").fadeOut("slow");
		// 	}
		// });
		$('#videoClose').click(function(e) {
			e.preventDefault();
			$('#videoCta').hide();
		});


		$('#booking-trigger').click(function(e){
			e.preventDefault();
			$('#booking-content').slideToggle();
		});

		$('.close-rfp').click(function(e){
			e.preventDefault();
			$('#booking-content').slideToggle();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		$(".sym-slides-events").slick({
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 7000,
			speed: 500,
			fade: false,
			accessibility: false,
			pauseOnHover: false,
			mobileFirst: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
			]
		});

	});


}());
